module.exports = __webpack_public_path__ + "img/logo.9915c2fb.jpg";